var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 13.548,
    "aria-hidden": "true",
    viewBox: "0 0 17.732 13.548"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.613 10.67 1.443 6.5.023 7.91l5.59 5.59 12-12-1.41-1.41z"
  })));
};
export default SvgCheck;